import React, { useState } from "react"
import SingleTicketCard from "./SingleTicketCard"
import FlightDetails from "./FlightDetails"
import DetailsTop from "./DetailsTop"
import DetailsBottom from "./DetailsBottom"
import DayBadge from "./DayBadge"
import { motion } from "framer-motion"
import { prepareSingleTicketCards } from "../../utils/processing/search"
import { useTranslation } from "react-i18next"
import {
  useLazyGetOptimUrlQuery,
  useLazyReserveBundleQuery,
} from "../../../../../app/services/book/bundle"
import { useSelector } from "react-redux"
import { selectAviaSearchCurrency } from "../../../../../app/reducers/book/aviaSearchSlice"

const FlightTicketCard = ({ onClick, item, airlines, passengers }) => {
  const { t, i18n } = useTranslation()

  const locale = i18n.language

  // selectors
  const currency = useSelector(selectAviaSearchCurrency)

  const isRoundTrip = Boolean(item?.retur_available && item?.depart_available)

  const cards = prepareSingleTicketCards(item, t)

  //
  const [isLoading, setIsLoading] = useState(false)

  // services
  const [reserveBundle] = useLazyReserveBundleQuery()
  const [getOptimUrl] = useLazyGetOptimUrlQuery()

  // handlers
  const handleBundle = async () => {
    const defaultCard = cards[0]

    try {
      setIsLoading(true)

      const resp = await getOptimUrl({
        price_id: defaultCard?.requestId,
        token: defaultCard?.session,
        locale,
      }).unwrap()

      const targetUrl = resp.url || resp.redirect

      if (targetUrl) {
        window.open(targetUrl, "_blank", "noopener,noreferrer")
      }
    } catch (error) {
      console.error("bundle request err:", error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <motion.div
      onClick={() => onClick(cards)}
      className="shadow-md cursor-pointer rounded-md bg-white overflow-clip w-full px-2 pr-8"
      whileHover={{ scale: 1.01, boxShadow: "0 4px 10px rgba(0,0,0,0.1)" }}
      transition={{ type: "spring", stiffness: 200, damping: 25 }}
    >
      <div className="grid w-full grid-cols-[70%_1fr] lg:grid-cols-[80%_1fr]">
        <div className="relative">
          {isRoundTrip && (
            <div className="absolute top-1/2 left-4 right-0 border-b border-light-gray/30" />
          )}

          <div className="absolute right-0 top-4 bottom-4 border-l border-light-gray/30" />

          {cards.map((card) => (
            <SingleTicketCard
              isSingleCard={cards?.length === 1}
              key={card.type}
              card={card}
              locale={locale}
              t={t}
              airlines={airlines}
            />
          ))}
        </div>

        <div className="flex relative flex-col py-1 pb-2 justify-between">
          {isRoundTrip && (
            <>
              <div className="absolute z-0 top-1/2 left-0 right-0 border-b border-light-gray/30" />
              <DayBadge nights={item?.nights} t={t} />
            </>
          )}
          <DetailsTop t={t} />
          <DetailsBottom
            passengers={passengers}
            price={item.cost}
            currency={item.currency}
            handleBundle={handleBundle}
            t={t}
            isLoading={isLoading}
          />
        </div>
      </div>
    </motion.div>
  )
}

export default FlightTicketCard
